import React from 'react';
import './Styles/Keyboard.css';

/**
 * Component rendering a keyboard and handling the key presses.
 *
 * Expected props:
 * - keyboard: array of strings that define keyboard layout, e.g. ['qwertyuiop', 'asdfghjkl', 'zxcvbnm']
 * - keysPressed: a string containing all keys that should be rendered as already pressed
 * - handleKeyPress(key): a callback function, called when a key is pressed
 */
export class Keyboard extends React.Component {
  render() {
    return (
      <div className="Keyboard">{this.props.keyboard.map(this.renderRow)}</div>
    );
  }

  renderRow = (row, index) => {
    return (
      <div key={index} className="Keyboard__Row">
        {row.split('').map(this.renderKey)}
      </div>
    );
  };

  renderKey = (key, index) => {
    let classes = 'Keyboard__Key ';
    if (this.props.keysPressed.includes(key)) {
      classes += 'Keyboard__Key--Pressed ';
    }
    return (
      <div
        key={key + index}
        className={classes}
        onClick={() => this.props.handleKeyPress(key)}
      >
        {key}
      </div>
    );
  };
}
